import { SelectOption } from 'src/modules/home/dashboard/filters/AsyncMultipleSelect'

export function mapIdsSelectOptions(options: SelectOption[]) {
  return options.map(option => option.value)
}
